import React from 'react';
import { InputAdornment, SxProps, TextField } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';

type Props = {
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
  searchPlaceholder: string;
  sx?: SxProps;
};

export const SearchField = ({ searchTerm, searchPlaceholder, sx, setSearchTerm }: Props) => {
  return (
    <TextField
      data-testid="search-input"
      sx={{
        width: 255,
        '& .MuiInputBase-root': { paddingX: '8px' },
        '& .MuiInputBase-input': { paddingY: '4px', fontSize: '1.4rem' },
        '& .MuiSvgIcon-root': {
          fontSize: '2rem',
        },
        ...sx,
      }}
      size="small"
      placeholder={searchPlaceholder}
      value={searchTerm}
      onChange={(event) => setSearchTerm(event.target.value)}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {searchTerm && (
              <ClearIcon sx={{ cursor: 'pointer' }} onClick={() => setSearchTerm('')} />
            )}
          </InputAdornment>
        ),
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />
  );
};
